
/**
 * @see "OFX Spec, Section 11.3.1.1"
 */
export enum AccountType {

  CHECKING,

  SAVINGS,

  MONEYMRKT,

  CREDITLINE

}
